<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">Type de marché</h1>
    </div>
    <MarketTypeForm createMode />
  </div>
</template>

<script>
  import MarketTypeForm from './MarketTypeForm.vue';

  export default {
    name: 'MarketTypeCreate',
    components: { MarketTypeForm },
  };
</script>
